"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = progress;

var _input = _interopRequireDefault(require("./input"));

// returns a binder for textarea element
function progress() {
  return (0, _input["default"])();
}
//# sourceMappingURL=progress.js.map